import {
  Bold700,
  ExtraBold900,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  LightNormal600,
  Normal400,
  Thin300,
} from "../../../Constant";

export const HeadingsData = [
  { className: "h2 txt-secondary", tittle: Heading2 },
  { className: "h3 txt-success", tittle: Heading3 },
  { className: "h4 txt-info", tittle: Heading4 },
  { className: "h5 txt-warning", tittle: Heading5 },
  { className: "h6 txt-danger", tittle: Heading6 },
];

export const FontsData = [
  { tittle: Thin300, className: "f-w-300" },
  { tittle: Normal400, className: "f-w-400" },
  { tittle: LightNormal600, className: "f-w-600" },
  { tittle: Bold700, className: "f-w-700" },
  { tittle: ExtraBold900, className: "f-w-900" },
];

export let TextColordatas =[
  {className:"txt-secondary",text:"This is Secondary text You can archive this adding"},
  {className:"txt-success",text:"This is success text You can archive this adding"},
  {className:"txt-info",text:"This is info text You can archive this adding"},
  {className:"txt-warning",text:"This is warning text You can archive this adding"},
  {className:"txt-danger",text:"This is danger text You can archive this adding"},
  {className:"txt-dark",text:"This is dark text You can archive this adding"},
  {className:"txt-primary",text:"This is primary text You can archive this adding"},
]

export let BlockquotesDatas = [
  {
    tittle: "Alignment Center",
    class: "text-center",
    text: "  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integerposuere erat a ante.",
    footer: "Someone famous in",
    lastFooter: "Source Title",
  },
  {
    tittle: "Alignment Right",
    class: "text-end mb-0",
    text: "  Lorem ipsum dol or sit amet, consectetur adipiscing elit. Integerposuere erat a ante.",
    footer: "Someone famous in",
    lastFooter: "Source Title",
  },
];
